import React from 'react';
import {Button, Stack} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {Box} from "shared-lib";

type Props = {};
export const SignUpResultPage: React.FunctionComponent<Props> = () => {
    const {t} = useTranslation();

    return <Stack className="login-page min-vh-100 justify-content-center align-items-center bg-dark">
        <img className="login-page__logo mb-4" src="./logo_440x64.png"/>
        <Box className="login-page__form">
            <Stack direction="vertical">
                <p>{t('signUp.result.message')}</p>
                <Button variant="primary" href="/">{t('common.goToHomePage')}</Button>
            </Stack>
        </Box>
    </Stack>
}

